import { render } from "./ExamBadgeTag.vue?vue&type=template&id=e78f64ce&scoped=true"
import script from "./ExamBadgeTag.vue?vue&type=script&lang=js"
export * from "./ExamBadgeTag.vue?vue&type=script&lang=js"

import "./ExamBadgeTag.vue?vue&type=style&index=0&id=e78f64ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e78f64ce"]])

export default __exports__